/**
 * Service TOC Dashboard (Fase 9 — ADR-0024).
 *
 * Endpoints REST de leitura agregada sobre OrdemProducao + ManufacturingEvent.
 * Toda metrica calculada em runtime no backend (sem cache nesta fase).
 */

const PREFIXO = "/api/toc";

/**
 * Payload unico com todas as metricas.
 *
 * @param {object} request - funcao request do AuthContext
 * @param {object} params - {janela:"7d"|"30d"|"90d", unidade, limite_minutos}
 */
export function obterDashboardToc(request, params = {}) {
  const usp = new URLSearchParams();
  if (params.janela) usp.set("janela", params.janela);
  if (params.unidade) usp.set("unidade", params.unidade);
  if (params.limite_minutos) {
    usp.set("limite_minutos", String(params.limite_minutos));
  }
  const qs = usp.toString();
  return request(`${PREFIXO}/dashboard${qs ? `?${qs}` : ""}`);
}

export function obterThroughput(request, params = {}) {
  const usp = new URLSearchParams();
  if (params.janela) usp.set("janela", params.janela);
  if (params.unidade) usp.set("unidade", params.unidade);
  const qs = usp.toString();
  return request(`${PREFIXO}/throughput${qs ? `?${qs}` : ""}`);
}

export function obterWip(request, params = {}) {
  const usp = new URLSearchParams();
  if (params.unidade) usp.set("unidade", params.unidade);
  const qs = usp.toString();
  return request(`${PREFIXO}/wip${qs ? `?${qs}` : ""}`);
}

export function obterGargalo(request, params = {}) {
  const usp = new URLSearchParams();
  if (params.unidade) usp.set("unidade", params.unidade);
  const qs = usp.toString();
  return request(`${PREFIXO}/gargalo${qs ? `?${qs}` : ""}`);
}

export function obterBuffer(request, params = {}) {
  const usp = new URLSearchParams();
  if (params.unidade) usp.set("unidade", params.unidade);
  if (params.limite_minutos) {
    usp.set("limite_minutos", String(params.limite_minutos));
  }
  const qs = usp.toString();
  return request(`${PREFIXO}/buffer${qs ? `?${qs}` : ""}`);
}

// ---------- Helpers de formatacao (UI) ----------

export const ZONA_LABELS = {
  verde: "Saudavel",
  amarelo: "Atenção",
  vermelho: "Risco",
};

export const ZONA_TONES = {
  verde: "success",
  amarelo: "warning",
  vermelho: "danger",
};

export const JANELAS = [
  { value: "7d", label: "Últimos 7 dias" },
  { value: "30d", label: "Últimos 30 dias" },
  { value: "90d", label: "Últimos 90 dias" },
];

/**
 * Formata minutos como "Xh Ym" ou "Ym".
 */
export function formatarMinutos(minutos) {
  if (typeof minutos !== "number" || minutos < 0) return "0m";
  if (minutos < 60) return `${minutos}m`;
  const horas = Math.floor(minutos / 60);
  const min = minutos % 60;
  return min > 0 ? `${horas}h ${min}m` : `${horas}h`;
}

/**
 * Formata numero como R$ brasileiro.
 */
export function formatarReais(valor) {
  const num = typeof valor === "string" ? Number(valor) : valor;
  if (typeof num !== "number" || Number.isNaN(num)) return "R$ 0,00";
  return num.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
}
